module.exports = __webpack_public_path__ + "static/pic08.95398946.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pics/pic08.jpg
// module id = 523
// module chunks = 159055269280251